import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { GET_COMPAIGN_SUMMARY, GET_COMPAIGN_SUMMARY_SUCCESS, GET_COMPAIGN_SUMMARY_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getCompaignSummary({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaign-stats`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMPAIGN_SUMMARY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMPAIGN_SUMMARY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMPAIGN_SUMMARY_ERROR, payload: error });
  }
}

export function* watchgetCompaignSummary() {
  yield takeEvery(GET_COMPAIGN_SUMMARY, getCompaignSummary);
}

function* getCompaignSummarySaga() {
  yield all([fork(watchgetCompaignSummary)]);
}

export default getCompaignSummarySaga;
